import styled from '@emotion/styled';
import { Row } from 'antd';
import BackgroundImg from './images/Background.svg';

export const RootContainer = styled(Row)`
  background-image: url(${BackgroundImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
`;
